import React, { forwardRef } from 'react';
import './Banner4.css';
import Banner4 from '../../Assets/banner4.png'; // Adjust the path if needed
import Banner4Mob from '../../Assets/banner4-mob.png'; // Adjust the path if needed

const Banner = forwardRef((props, ref) => {
  return (
    <div ref={ref} className="banner4-div">
      <img className="banner4 desktop" src={Banner4} alt="Banner4" />
      <img className="banner4 mobile" src={Banner4Mob} alt="Banner4 Mobile" />
    </div>
  );
});

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner4/Banner4.js